import { inject } from '@angular/core';
import { CanActivateFn, Router } from '@angular/router';
import { AuthService } from '@features/auth/services/auth.service';
import { IAuthStatusEnum } from '@features/auth/interfaces/auth.interface';
import { map } from 'rxjs';

export const isAuthenticatedGuard: CanActivateFn = (route, state) => {
  const _router = inject(Router);
  const _authService = inject(AuthService);

  if (_authService.authStatus() === IAuthStatusEnum.notAuthenticated) return true;

  return _authService.checkAuthStatus().pipe(
    map((response: boolean) => {
      if (!response) return true;
      return _router.createUrlTree(['/home']);
    })
  );
};
